/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: <explanation> */
import { Module } from "@ak/game-assets"
import { Coupon, useDraws } from "@hg/recall-frame"
import cls from "classnames"
import { isEmpty } from "lodash"
import React, { FC, useMemo, useState } from "react"
import OutlinedText from "@/components/OutlinedText"
import { i18n, RecallTextPath } from "@/i18n"
import {
    RevertRewardMap,
    RLRewardMap,
    RLSrcs,
    VRRewardMap,
} from "@/Topics/Recall/const/reward"
import { Client } from "@/utils/gameAssets"
import styles from "./index.module.scss"
import OutlineButton from "@/components/OutlineButton"
import { EditAddressModal } from "@/components/EditAddressModal"
import type { ContactInfo } from "@/services/activity"
// import { RuleButton } from "@/Topics/Recall/components/Modals/Rules"

const AWARD_TITLE_MAX_WIDTH = 156

export const Award: FC = () => {
    const drawSwr = useDraws()

    const awardList = useMemo(() => {
        // return [
        //     {
        //         result: {
        //             prizeName: "recall-draw-prize-7",
        //         },
        //     },
        //     {
        //         result: {
        //             prizeName: "recall-draw-prize-6",
        //         },
        //     },
        //     {
        //         result: {
        //             prizeName: "recall-draw-prize-5",
        //         },
        //     },
        //     {
        //         result: {
        //             prizeName: "recall-draw-prize-4",
        //         },
        //     },
        //     {
        //         result: {
        //             prizeName: "recall-draw-prize-3",
        //         },
        //     },
        //     {
        //         result: {
        //             prizeName: "recall-draw-prize-2",
        //         },
        //     },
        //     {
        //         result: {
        //             prizeName: "recall-draw-prize-1",
        //         },
        //     },
        //     {
        //         result: {
        //             prizeName: "gd-card",
        //         },
        //     },
        // ] as Coupon[]
        if (!drawSwr.data?.coupons) {
            return []
        }
        const arr = drawSwr.data.coupons.filter(
            (q: Coupon) =>
                !!q.result &&
                q.result?.giftName &&
                q.cid === __RECALL_COUPON_CID
        )
        return arr
    }, [drawSwr])

    const hasGoods = useMemo(() => {
        // return true
        return !!awardList.find((q) => q.result?.prizeType === "GOODS")
    }, [awardList])

    return (
        <div className={styles.award}>
            {/* <RuleButton className={styles.smallRule} /> */}
            {awardList.length > 0 && (
                <div className={styles.card}>
                    <div className={styles.items}>
                        {awardList.map((q: Coupon, idx: number) => (
                            <Item
                                key={`award-list-${q.name}`}
                                giftName={q.result.giftName}
                            />
                        ))}
                    </div>
                </div>
            )}
            {!awardList.length && (
                <div className={styles.empty}>
                    <div className={styles.text}>
                        {i18n.getRecall("record.empty")}
                    </div>
                </div>
            )}
            {hasGoods && <Address />}
        </div>
    )
}

const Item: FC<{ giftName: string }> = ({ giftName }) => {
    const rewardInfo = useMemo(() => {
        const prizeKey = RevertRewardMap?.[giftName]

        if (prizeKey in VRRewardMap) {
            const item = VRRewardMap[prizeKey as keyof typeof VRRewardMap]
            return {
                src: Client.get(Module.ITEM, item.key),
                title: `${i18n.getRecall(item.name as RecallTextPath)} \nx${item.amount}`,
                type: "gf",
            }
        }
        if (prizeKey in RLRewardMap) {
            const item = RLRewardMap[prizeKey as keyof typeof RLRewardMap]
            return {
                src: RLSrcs[item.key as keyof typeof RLSrcs],
                title: `${i18n.getRecall(item.name as RecallTextPath)}`,
                type: "rl",
            }
        }
        return null
    }, [giftName])

    const adjustedFontSize = useMemo(() => {
        if (!rewardInfo?.title) {
            return 34
        }

        const len = rewardInfo.title.length
        if (len <= 10) return 28
        if (len <= 12) return 26
        if (len <= 16) return 20
        return 18
    }, [rewardInfo?.title])

    if (!rewardInfo) {
        return null
    }

    return (
        <div className={cls(styles.item, styles[rewardInfo?.type])}>
            <div className={cls(styles.top)}>
                <img src={rewardInfo.src} alt={giftName} />
            </div>
            <div className={styles.bottom}>
                <div className={cls(styles.rect)}>
                    <OutlinedText
                        text={rewardInfo.title}
                        fontFamily="FOT-MatisseVPro-EB"
                        fontSize={adjustedFontSize}
                        strokeWidth={6}
                        fillColor="#8f7254"
                        strokeColor="#fff"
                        maxWidth={AWARD_TITLE_MAX_WIDTH}
                        style={{ overflow: "visible" }}
                        wrap
                    />
                </div>
            </div>
        </div>
    )
}

const Address: FC = () => {
    const drawSwr = useDraws()
    const contactInfo = useMemo(() => {
        const map = drawSwr.data?.contactInfo as unknown as Record<string, ContactInfo | null> | null | undefined
        return map?.[__RECALL_COUPON_CID] ?? null
    }, [drawSwr])

    const title = useMemo(() => {
        if (!contactInfo || isEmpty(contactInfo)) {
            return i18n.getRecall("record.set_address")
        } else {
            return i18n.getRecall("record.show_address")
        }
    }, [contactInfo])

    const [open, setOpen] = useState(false)
    const showEditAddressModal = () => {
        setOpen(true)
    }

    return (
        <div className={styles.address}>
            <OutlineButton
                className={styles.editBtn}
                text={title}
                onClick={showEditAddressModal}
                fontSize={20}
                fitWidth={210}
            />
            <EditAddressModal
                open={open}
                onClose={() => setOpen(false)}
                contactInfo={contactInfo}
                coupon={__RECALL_COUPON_CID}
                onRefresh={() => drawSwr.mutate()}
            />
        </div>
    )
}
